import type { RecRequest } from "./types";

export abstract class Rec {
  public readonly request: RecRequest;

  constructor(data: RecRequest) {
    this.request = {
      ...data,
    };
  }
}
